import React from 'react';
import { Link } from 'react-router';

import './not-found.css';

export const NotFound = () => (
  <div className="blog-post-not-found">
    <h1 className="blog-post-not-found__title">Post Not Found</h1>
    <p className="blog-post-not-found__content">
      We couldn't find the post you're looking for. You can find all of our
      posts <Link to="/blog">here</Link>.
    </p>
  </div>
);
